module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"domain_score":"Domain score","score":"Score"},"fr":{"domain_score":"Score de domaine","score":"Score"},"de":{"domain_score":"Domain-Score","score":"Punktzahl"}}')
  delete Component.options._Ctor
}
